import { faChartPie } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { UpdatePollForm } from '~/components/forms/PollForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';
import { usePollQuery } from '~/lib/api/modules/Polls/hooks/usePollQuery';

export type IAppUpdatePollPageProps = {
  appId: string;
  pollId: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const AppUpdatePollPage: React.FC<IAppUpdatePollPageProps> = (props) => {
  const { appId, pollId, nextUrl, cancelUrl } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pollQuery = usePollQuery({
    appId,
    pollId,
  });

  const parentUrl = `/apps/${appId}/polls`;

  return (
    <>
      <Helmet>
        <title>{t('AppUpdatePollPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faChartPie} />
          {t('AppPollsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={
          <QuerySkeleton query={pollQuery} length={{ min: 8, max: 16 }}>
            {t('AppUpdatePollPage.title', {
              title: pollQuery.data?.title,
            })}
          </QuerySkeleton>
        }
        previousUrl={parentUrl}
      />

      <UpdatePollForm
        appId={appId}
        pollId={pollId}
        onSuccess={() => navigate(nextUrl ?? parentUrl)}
        cancelUrl={cancelUrl ?? parentUrl}
      />
    </>
  );
};
